// @ts-nocheck
/* eslint-disable */
/* tslint:disable */
/* prettier-ignore-start */
import React from "react"
import { classNames } from "@plasmicapp/react-web"

export function SliderIcon(props) {
  const { className, style, title, ...restProps } = props
  return (
    <svg
      xmlns={"http://www.w3.org/2000/svg"}
      fill={"none"}
      viewBox={"0 0 94 10"}
      height={"1em"}
      width={"1em"}
      style={{
        fill: "currentcolor",
        ...(style || {}),
      }}
      className={classNames("plasmic-default__svg", className)}
      {...restProps}
    >
      {title && <title>{title}</title>}

      <circle
        opacity={".3"}
        cx={"33"}
        cy={"5"}
        r={"5"}
        fill={"currentColor"}
      ></circle>

      <circle
        opacity={".3"}
        cx={"61"}
        cy={"5"}
        r={"5"}
        fill={"currentColor"}
      ></circle>

      <circle
        opacity={".3"}
        cx={"89"}
        cy={"5"}
        r={"5"}
        fill={"currentColor"}
      ></circle>

      <circle cx={"5"} cy={"5"} r={"5"} fill={"currentColor"}></circle>
    </svg>
  )
}

export default SliderIcon
/* prettier-ignore-end */
